export const reportDataValidator = ({ name, startDate }) => {
  if (!name || !startDate) {
    throw new Error('Preenche o nome e a data de início');
  }
};
